var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.2526V49.4963L40 58.9188L57.5 49.4963V29.2526L40 19.8301L22.5 29.2526ZM53.6125 30.0001L40 37.3301L26.3875 30.0001L40 22.6701L53.6125 30.0001ZM25 32.0926L38.75 39.4963V55.4063L25 48.0026V32.0926ZM41.25 55.4076V39.4963L55 32.0926V48.0026L41.25 55.4076Z",
    fill: "url(#paint0_linear_180_6419)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 47.6V32.4C75.4825 31.79 78.75 28.1488 78.75 23.75C78.75 18.9263 74.8238 15 70 15C67.0287 15 64.4025 16.4925 62.82 18.7625L48.59 11.6475C48.6913 11.1125 48.75 10.5638 48.75 10C48.75 5.17625 44.8237 1.25 40 1.25C35.1763 1.25 31.25 5.17625 31.25 10C31.25 10.5638 31.3088 11.1125 31.4112 11.6475L17.18 18.7625C15.5975 16.4913 12.9713 15 10 15C5.17625 15 1.25 18.9263 1.25 23.75C1.25 28.1488 4.5175 31.79 8.75 32.4V47.6C4.5175 48.21 1.25 51.8512 1.25 56.25C1.25 61.0737 5.17625 65 10 65C12.9713 65 15.5975 63.5075 17.18 61.2375L31.4112 68.3537C31.3088 68.8875 31.25 69.4362 31.25 70C31.25 74.8238 35.1763 78.75 40 78.75C44.8237 78.75 48.75 74.8238 48.75 70C48.75 69.4362 48.6913 68.8875 48.59 68.3525L62.8213 61.2362C64.4025 63.5075 67.0287 65 70 65C74.8238 65 78.75 61.0737 78.75 56.25C78.75 51.8512 75.4825 48.21 71.25 47.6ZM70 17.5C73.4463 17.5 76.25 20.3037 76.25 23.75C76.25 27.1963 73.4463 30 70 30C66.5537 30 63.75 27.1963 63.75 23.75C63.75 20.3037 66.5537 17.5 70 17.5ZM40 3.75C43.4463 3.75 46.25 6.55375 46.25 10C46.25 13.4462 43.4463 16.25 40 16.25C36.5537 16.25 33.75 13.4462 33.75 10C33.75 6.55375 36.5537 3.75 40 3.75ZM3.75 23.75C3.75 20.3037 6.55375 17.5 10 17.5C13.4462 17.5 16.25 20.3037 16.25 23.75C16.25 27.1963 13.4462 30 10 30C6.55375 30 3.75 27.1963 3.75 23.75ZM10 62.5C6.55375 62.5 3.75 59.6963 3.75 56.25C3.75 52.8037 6.55375 50 10 50C13.4462 50 16.25 52.8037 16.25 56.25C16.25 59.6963 13.4462 62.5 10 62.5ZM40 76.25C36.5537 76.25 33.75 73.4463 33.75 70C33.75 66.5537 36.5537 63.75 40 63.75C43.4463 63.75 46.25 66.5537 46.25 70C46.25 73.4463 43.4463 76.25 40 76.25ZM47.76 65.9725C46.2988 63.1712 43.3713 61.25 40 61.25C36.6287 61.25 33.7012 63.1712 32.24 65.9725L18.3 59.0025C18.5875 58.135 18.75 57.2125 18.75 56.25C18.75 51.8512 15.4825 48.21 11.25 47.6V32.4C15.4825 31.79 18.75 28.1488 18.75 23.75C18.75 22.7875 18.5875 21.865 18.3 20.9975L32.2412 14.0275C33.7012 16.8287 36.6287 18.75 40 18.75C43.3713 18.75 46.2988 16.8287 47.76 14.0275L61.7012 20.9975C61.4125 21.865 61.25 22.7875 61.25 23.75C61.25 28.1488 64.5175 31.79 68.75 32.4V47.6C64.5175 48.21 61.25 51.8512 61.25 56.25C61.25 57.2125 61.4125 58.135 61.7 59.0025L47.76 65.9725ZM70 62.5C66.5537 62.5 63.75 59.6963 63.75 56.25C63.75 52.8037 66.5537 50 70 50C73.4463 50 76.25 52.8037 76.25 56.25C76.25 59.6963 73.4463 62.5 70 62.5Z",
    fill: "url(#paint1_linear_180_6419)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 22.5H68.75V25H71.25V22.5Z",
    fill: "url(#paint2_linear_180_6419)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 55H68.75V57.5H71.25V55Z",
    fill: "url(#paint3_linear_180_6419)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 68.75H38.75V71.25H41.25V68.75Z",
    fill: "url(#paint4_linear_180_6419)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 55H8.75V57.5H11.25V55Z",
    fill: "url(#paint5_linear_180_6419)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5H8.75V25H11.25V22.5Z",
    fill: "url(#paint6_linear_180_6419)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 8.75H38.75V11.25H41.25V8.75Z",
    fill: "url(#paint7_linear_180_6419)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6419",
    x1: 22.5002,
    y1: 39.3747,
    x2: 57.5,
    y2: 39.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6419",
    x1: 1.25038,
    y1: 40.0006,
    x2: 78.75,
    y2: 40.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6419",
    x1: 68.75,
    y1: 23.75,
    x2: 71.25,
    y2: 23.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_6419",
    x1: 68.75,
    y1: 56.25,
    x2: 71.25,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_180_6419",
    x1: 38.75,
    y1: 70,
    x2: 41.25,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_180_6419",
    x1: 8.75001,
    y1: 56.25,
    x2: 11.25,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_180_6419",
    x1: 8.75001,
    y1: 23.75,
    x2: 11.25,
    y2: 23.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_180_6419",
    x1: 38.75,
    y1: 10,
    x2: 41.25,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.758fbb174cada67159a37d802c9ddc6d.svg";
export { ForwardRef as ReactComponent };